var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSeeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 28,
    viewBox: "0 0 6 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.269531 3.12402C0.269531 4.49341 1.37964 5.60352 2.74902 5.60352C4.11841 5.60352 5.22852 4.49341 5.22852 3.12402C5.22852 1.75464 4.11841 0.644531 2.74902 0.644531C1.37964 0.644531 0.269531 1.75464 0.269531 3.12402ZM0.2771 13.8839C0.2771 15.2512 1.3855 16.3596 2.75281 16.3596C4.12012 16.3596 5.22852 15.2512 5.22852 13.8839C5.22852 12.5166 4.12012 11.4082 2.75281 11.4082C1.3855 11.4082 0.2771 12.5166 0.2771 13.8839ZM2.75293 27.1152C1.38574 27.1152 0.277466 26.0068 0.277466 24.6396C0.277466 23.2724 1.38574 22.1641 2.75293 22.1641C4.12012 22.1641 5.22852 23.2724 5.22852 24.6396C5.22852 26.0068 4.12012 27.1152 2.75293 27.1152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeeMore);
export default __webpack_public_path__ + "static/media/IconSeeMore.d402b6607f227a5fe53dd0b1fdc49580.svg";
export { ForwardRef as ReactComponent };